const suggestedTopics = [
    // QA Leadership & Strategy
    "How to Convince Executives That Quality Engineering Isn't a Cost Center",
    "The Hidden Cost of Manual QA Reporting: What 2 Hours Per Day Really Means",
    "Why Your QA Metrics Don't Speak Executive Language (And How to Fix It)",
    "From Reactive Testing to Strategic Quality Engineering: A Transformation Guide",

    // Technical Debt & Architecture
    "Technical Debt in Testing: When to Fix, When to Live With It",
    "The Real Impact of Flaky Tests on Team Morale and CI Trust",
    "Breaking the Build-Fix-Repeat Cycle: Root Cause Analysis That Actually Works",
    "Why Your Test Suite is Slow (And What Science Says About Fixing It)",

    // Business Impact & ROI
    "Translating Test Coverage Percentages into Revenue Impact Numbers",
    "The $200K Question: What Are Escaped Defects Really Costing You?",
    "Building a QA Business Case That Finance Actually Approves",
    "How to Prove QA ROI When You Can't Measure Everything",

    // Team & Process
    "Preventing QA Burnout: Early Warning Signs Every Leader Should Know",
    "The Automation Paradox: Why More Scripts Don't Always Mean Better Quality",
    "Building High-Performing QA Teams in a Remote-First World",
    "Code Review Metrics That Actually Improve Code Quality",

    // Tools & Integration
    "The Integration Nightmare: Managing 10+ QA Tools Without Losing Your Mind",
    "Why Your Jenkins-Jira-SonarQube Stack Needs a Unified Dashboard",
    "Escaping Tool Sprawl: Consolidating QA Data in the Age of DevOps",
    "The Morning Data Ritual: How 2 Hours of Manual Pulling Destroys Productivity"
];

module.exports = suggestedTopics;
